/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmUrlWeboveAplikace extends GContentBase<SeznamAdmUrlWeboveAplikaceObj> {
        private seznamObj: SeznamAdmUrlWeboveAplikaceObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmUrlWeboveAplikaceObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmUrlWeboveAplikaceNew",
                contentCaption: "jres:33000681", //RC 33000681 : URL programov�ch f�z�
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{lic} - {faze}"
                },
                gridSettings: {
                    columnOrder: "lic,faze,nazev,url,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmUrlWeboveAplikaceObj extends GAdmSeznamBase {
        faze: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmUrlWeboveAplikace", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmUrlWeboveAplikace",
                newRecord: isNew,
                lic: isNew == true ? null : data.lic,
                faze: isNew == true ? (this.faze) ? this.faze : null : data.faze,
                por_cislo: isNew == true ? null : data.por_cislo
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:32131111").addField("gselectbox", Gordic.Prefabs.Select.gincfaz(), {
                name: "faze",
                model: "model.faze=value.faze",
                dropdown: true,
                disabled: this.faze ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.faze)
                hardFilter["faze"] = this.faze;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.faze)
                data["faze"] = this.faze
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmUrlWeboveAplikace.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}#".format(data.lic, data.faze, data.por_cislo),
                nazev: data["nazev"]
            }
        }
    }
}